import './lib/audiencePreferences'
import './profile-entry.css'
import { captureInitialCampaign } from './lib/analytics'
import { readPublicRoute } from './lib/publicRoute'
import { initializeSortableTables } from './lib/sortableTable'
import { initializeStaticDocument } from './lib/staticDocument'

captureInitialCampaign(window.location.search)
initializeStaticDocument(readPublicRoute())
initializeSortableTables()

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target.closest<HTMLElement>('[data-copy-profile], [data-copy-embed], [data-share-profile]') : null
  if (!target) return
  if (target.hasAttribute('data-copy-profile')) {
    try {
      await navigator.clipboard.writeText(window.location.href)
      const original = target.textContent
      target.textContent = target.dataset.copySuccess || original
      window.setTimeout(() => { target.textContent = original }, 1800)
    } catch {
      window.prompt(target.dataset.copyPrompt || 'Copy this link', window.location.href)
    }
    return
  }
  if (target.hasAttribute('data-copy-embed')) {
    const value = target.dataset.embed || ''
    try {
      await navigator.clipboard.writeText(value)
      const original = target.textContent
      target.textContent = target.dataset.copySuccess || original
      window.setTimeout(() => { target.textContent = original }, 1800)
    } catch {
      window.prompt(target.dataset.copyPrompt || 'Copy this embed code', value)
    }
    return
  }
  const title = document.title
  if (navigator.share) {
    try { await navigator.share({ title, url: window.location.href }) } catch { /* cancelled */ }
  } else if (target.dataset.shareUrl) {
    window.open(target.dataset.shareUrl, '_blank', 'noopener,noreferrer')
  }
})
